import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Grid,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./FAQ.module.css";
import { Helmet } from "react-helmet";

const FAQ = () => {
  const faqData = [
    {
      question: "What type of images can I generate with this AI?",
      answer:
        "Our AI can generate various types of images including landscapes, portraits, abstract art, and concept designs. You can guide the generation process using text prompts.",
    },
    {
      question: "How long does it take to generate an image?",
      answer:
        "Generation time typically ranges from 5 to 30 seconds depending on image complexity and server load.",
    },
    {
      question: "Can I use generated images commercially?",
      answer:
        "Yes, all images generated with our platform are royalty-free and can be used for commercial purposes.",
    },
    {
      question: "What image resolutions are supported?",
      answer:
        "We support resolutions from 512x512 up to 4K UHD (3840x2160). Higher resolutions may require premium credits.",
    },
    {
      question: "How does the AI handle copyright issues?",
      answer:
        "Our AI is trained on licensed and public domain datasets. All generated images are unique and don't replicate existing copyrighted works.",
    },
  ];

  // Create schema markup for FAQ
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <Container maxWidth="lg" className={styles.container}>
      <Helmet>
        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <Typography variant="h2" className={styles.heading}>
        Frequently Asked Questions
      </Typography>
      <Typography variant="h6" className={styles.subheading}>
        Can't find the answer you're looking for? Reach out to our customer
        support team
      </Typography>

      <Grid item xs={12} md={8}>
        {faqData.map((faq, index) => (
          <Accordion key={index} className={styles.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography className={styles.question}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={styles.answer}>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>
    </Container>
  );
};

export default FAQ;
